/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetailsStats_reviews = {
    readonly metadata: {
        readonly aggregatedFeedback: {
            readonly overallExperience: {
                readonly mean: number | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": "PdpRespDealerDetailsStats_reviews";
};
export type PdpRespDealerDetailsStats_reviews$data = PdpRespDealerDetailsStats_reviews;
export type PdpRespDealerDetailsStats_reviews$key = {
    readonly " $data"?: PdpRespDealerDetailsStats_reviews$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetailsStats_reviews">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerDetailsStats_reviews",
  "type": "SellerOrderFeedbackPdpQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "metadata",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "aggregatedFeedback",
          "storageKey": null,
          "args": null,
          "concreteType": "AggregatedOrderFeedbackType",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "overallExperience",
              "storageKey": null,
              "args": null,
              "concreteType": "AggregatedOrderFeedbackQuestionType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "mean",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'da7686425e1b933b4f9aaa2602d2ffd2';
export default node;
